import { compose } from 'ramda';

import { redirectTo, saveReturnPath } from '#src/store/location/actions';
import { selectQuery } from '#src/store/location/selectors';
import { isAuthenticatedOrProspect } from '#src/store/session/selectors';

export const path = '/signup';
export const component = 'Signup';
export const thunk = () => (dispatch, getState) => {
  const state = getState();
  const { returnPath } = selectQuery(state);

  if (isAuthenticatedOrProspect(state)) {
    compose(dispatch, redirectTo)(returnPath);
    return;
  }

  compose(dispatch, saveReturnPath)(returnPath);
};
